<template>
    <div v-bind:class="forLogout">
        <nav style="position: fixed;top:0; z-index: 999" v-if="logged_in">
            <div class="nav-wrapper">
                <a class="brand-logo left" href="#">
                    <img src="/ikona.svg" />
                </a>
                <div class="show-on-large hide-under1460">
                    <ul id="nav-mobile" class="center  upmenu" :class="{ upmenu: user_role != 'ddd_customer', 'upmenu-customer': user_role == 'ddd_customer' }">
                        <li v-bind:class="isDesktop" v-if="user_role != 'ddd_customer'">
                            <router-link active-class="selected" to="/desktop">
                                <i class="material-icons dp48">home</i>
                                {{ $t('menu.desktop') }}
                            </router-link>
                        </li>
                        <li v-bind:class="isCustomers" v-if="user_role != 'ddd_customer'">
                            <router-link active-class="selected" to="/customers">
                                <i class="material-icons dp48">account_box</i>
                                {{ $t('menu.customers') }}
                            </router-link>
                        </li>
                        <li v-bind:class="isPlaces"><router-link active-class="selected" to="/places">
                                <i class="material-icons dp48">place</i>
                                {{ $t('menu.places') }}</router-link></li>
                        <li v-bind:class="isInspections"><router-link active-class="selected" to="/inspections">
                                <i class="material-icons dp48">check_box</i>
                                {{ $t('menu.inspections') }}</router-link></li>
                        <li v-bind:class="isInstallations"><router-link active-class="selected" to="/installations">
                                <i class="material-icons dp48">build</i>
                                {{ $t('menu.installations') }}</router-link></li>
                        <li v-bind:class="isInterventions" style="letter-spacing: 0.5px"><router-link active-class="selected" to="/interventions">
                                <i class="material-icons dp48">content_paste</i>
                                {{ $t('menu.interventions') }}</router-link></li>
                         <li v-bind:class="isProtocols" style="letter-spacing: 0.5px" v-if="user_role == 'ddd_customer'">
                            <router-link active-class="selected" to="/protocols">
                                <i class="material-icons dp48">content_paste</i>
                                {{ $t('menu.protocols') }}
                            </router-link>
                        </li>
                        <li v-bind:class="isTasks" v-if="user_role != 'ddd_customer'"><router-link active-class="selected" to="/tasks">
                                <i class="material-icons dp48">insert_invitation</i>
                                {{ $t('menu.tasks') }}</router-link></li>
                        <li v-bind:class="isBases"><router-link active-class="selected" to="/bases">
                                <i class="material-icons dp48">storage</i>
                                {{ $t('menu.bases') }}</router-link></li>
                        <li v-bind:class="isSettings" style="letter-spacing: 0.5px"><router-link active-class="selected" to="/settings">
                                <i class="material-icons dp48">settings</i>
                                {{ $t('menu.settings') }}</router-link></li>
                    </ul>
                </div>
                <ul class="right hide-on-med-and-down hide-under1460" id="nav-mobile">
                    <li>
                        <a v-if="logged_in" v-on:click="log_out()" class="waves-effect waves-light btn red logout">
                            {{ $t('menu.logout') }}
                        </a>
                         <a  class="waves-effect waves-light btn red logout" v-on:click="toggleLanguage()">{{lang == 'en' ? 'EN' : 'PL'  }}</a>
                    </li>
                </ul>
                <hamburger>
                <a class="dropdown-trigger" data-target="dropdownmenu" style="width: 255px; text-align: right; margin: 0px;" init="init_selectors"><i class="material-icons medium">menu</i></a>

                <ul id="dropdownmenu" class="dropdown-content">
                     <li class="menuitems" v-if="user_role != 'ddd_customer'"><router-link active-class="selected" to="/desktop">
                                <i class="material-icons tiny" style="font-size: 20px !important;">home</i>
                                {{ $t('menu.desktop') }}</router-link></li>
                    <li class="menuitems" v-if="user_role != 'ddd_customer'"><router-link active-class="selected" to="/customers">
                                <i class="material-icons tiny" style="font-size: 20px !important;">account_box</i>
                                {{ $t('menu.customers') }}</router-link></li>
                    <li class="menuitems"><router-link active-class="selected" to="/places">
                                <i class="material-icons tiny" style="font-size: 20px !important;">place</i>
                                {{ $t('menu.places') }}</router-link></li>
                     <li class="menuitems"><router-link active-class="selected" to="/inspections">
                                <i class="material-icons tiny" style="font-size: 20px !important;">check_box</i>
                                {{ $t('menu.inspections') }}</router-link></li>
                    <li class="menuitems"><router-link active-class="selected" to="/installations">
                                <i class="material-icons tiny" style="font-size: 20px !important;">build</i>
                                {{ $t('menu.installations') }}</router-link></li>
                    <li class="menuitems" style="letter-spacing: 0.5px">
                        <router-link active-class="selected" to="/interventions">
                                <i class="material-icons tiny" style="font-size: 20px !important;">content_paste</i>
                                {{ $t('menu.interventions') }}
                        </router-link>
                    </li>
                    <li class="menuitems" v-if="user_role != 'ddd_customer'">
                        <router-link active-class="selected" to="/tasks">
                                <i class="material-icons tiny" style="font-size: 20px !important;">insert_invitation</i>
                                {{ $t('menu.tasks') }}</router-link>
                    </li>
                    <li class="menuitems"><router-link active-class="selected" to="/bases">
                                <i class="material-icons tiny" style="font-size: 20px !important;">storage</i>
                                {{ $t('menu.bases') }}</router-link></li>
                    <li class="menuitems"><router-link active-class="selected" to="/settings">
                                <i class="material-icons tiny" style="font-size: 20px !important;">settings</i>
                                {{ $t('menu.settings') }}</router-link></li>
                     <li v-bind:class="isSettings"><a v-if="logged_in" v-on:click="log_out()" class="waves-effect">
                        <i class="material-icons tiny" style="font-size: 20px !important;"></i>
                            {{ $t('menu.logout') }}
                        </a>
                    </li>
                </ul>
                </hamburger>
            </div>
        </nav>
        <div id="app" style="padding-top: 100px; ">
            <div v-if="loaded == false" style="width: 32px; margin: auto; border-bottom: 100px; height: 68vh;">
                <div class="preloader-wrapper big active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="scrollable" v-scroll="scrolled">
                <router-view
                    v-if="loaded"
                    :role="user_role"
                    :company_name="company_name"
                    :company_address="company_address"
                    :license="license"
                    :extended_privileges="extended_privileges"
                    :email="email"
                    :user_email="user_email"
                    :token="invitation_token"
                    v-on:logIn="onLogIn($event)"></router-view>
                <button class="btn btn-small hopbutton" v-if="showButton" v-on:click="hop()">{{$t('menu.jumpup')}}</button>
            </div>
        </div>
        <footer class="page-footer" v-if="logged_in == false">
            <div class="container">
                <div class="row">
                    <div class="col s1">
                        <a class="brand-logo" href="#">
                            <img src="/ikona.svg" />
                        </a>
                    </div>
                    <div class="col s3">
                        <h6 style="font-size: 1.15rem;line-height: 100%;margin: 0rem;">{{ $t('menu.data_administrator') }}</h6>
                        <p>FRODO Leszek Teschner</p>
                        <p><a href="https://www.google.com/maps?q=52.409401256824445, 16.838144312861353" target="_blank" style="color: black">ul. Jana Brzechwy 2, 60-195 Poznań</a></p>
                        <p>NIP 7821526416 REGON 634600953</p>
                    </div>
                    <div class="col offset-s1 s3">
                        <p>{{$t('menu.rules')}} <i class="material-icons">insert_drive_file</i></p>
                        <p>{{$t('menu.privacy_policy')}} <i class="material-icons">insert_drive_file</i></p>
                    </div>
                    <div class="col offset-s2 s2">
                        <h6 style="font-size: 1.15rem;line-height: 100%;margin: 0rem;">{{ $t('menu.contact') }}</h6>
                        <p><a href="mailto:bok@mobipest.pl" style="color: #000;">bok@mobipest.pl</a></p>
                        <p>+48 885 700 704</p>
                    </div>
                </div>
            </div>
            <div class="footer-copyright">
                <div class="container">
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import axios from 'axios';
import Cookies from 'js-cookie';
export default {
    data: function() {
        return {
            email: "",
            password: "",
            email_confirm: "",
            password_confirm: "",
            loaded: false,
            logged_in: false,
            logging_in: false,
            remember: false,
            register: false,
            remembering: false,
            remembered: false,
            nocaptchaError: false,
            error: "",
            page: 'desktop',
            session: {},
            recaptcha: "",
            customers: [],
            showButton: false,
            lang: Cookies.get('lang'),
            license: {},
            company_name: "",
            extended_privileges: false,
            user_role: null,
            invitation_token: null
        }
    },
    computed: {
        isDesktop: function() {
            return {
                'selected': window.location.hash == '#/desktop',
                'menuitems': true
            }
        },
        isCustomers: function() {
            return {
                'selected': window.location.hash == '#/customers',
                'menuitems': true
            }
        },
        isPlaces: function() {
            return {
                'selected': this.page == 'places',
                'menuitems': true
            }
        },
        isInspections: function() {
            return {
                'selected': this.page == 'inspections',
                'menuitems': true
            }
        },
        isInstallations: function() {
            return {
                'selected': this.page == 'installations',
                'menuitems': true
            }
        },
        isInterventions: function() {
            return {
                'selected': this.page == 'interventions',
                'menuitems': true
            }
        },
        isProtocols: function() {
            return {
                'selected': this.page == 'protocols',
                'menuitems': true
            }
        },
        isSettings: function() {
            return {
                'selected': this.page == 'settings',
                'menuitems': true
            }
        },
        isTasks: function() {
            return {
                'selected': this.page == 'tasks',
                'menuitems': true
            }
        },
        isBases: function() {
            return {
                'selected': this.page == 'bases',
                'menuitems': true
            }
        },
        forLogout: function() {
            return {
                'grayed': this.logged_in == false,
            }
        },


    },
    
    created() {
        this.log_in();
        if(document.getElementById('app').attributes['invitation_token'].value != ''){
            this.invitation_token = document.getElementById('app').attributes['invitation_token'].value
        }
        if(document.getElementById('app').attributes['alert'].value != ''){
            this.alert = document.getElementById('app').attributes['alert'].value
        }
    },
    mounted(){
    },
    methods: {
        scrolled: function(e, el){
            if(window.document.scrollingElement.clientHeight < (window.scrollY * 2)) this.showButton = true;
            else this.showButton = false;
        },
        hop: function(){
            window.scrollTo(0, 0);
        },
        onLogIn: function(sessionData){
            var session = sessionData.session
            this.user_role = session.role;
            this.session = session;
            this.license = session.license;
            this.company_name = session.company_name
            this.company_address = session.company_address
            this.email = session.email
            this.user_email = session.user_email
            this.logged_in = true;
            this.loaded = true;
            this.logging_in = false;
            this.extended_privileges = session.extended_priviliges;
            if(sessionData.fresh_session){
                window.app.app.role = session.role;
                this.$router.push('/after-login');
            }
        },
        log_in: function() {
            this.logging_in = true;
            axios.post('/users/sign_in.json', { "user": { "email": this.email, "password": this.password } })
                .then(response => {
                    this.onLogIn({ session: response.data, fresh_session: false });
                })
                .catch(e => {
                    if (e.response.status == 401) {
                        this.logged_in = false;
                        this.logging_in = false;
                        var notLogIn = this.$route.name != 'login';
                        var norResetPassword = this.$route.name != 'reset_password';
                        if(_.isNull(this.invitation_token) == false){
                            this.$router.push('/register');
                        }
                        if (notLogIn && norResetPassword) {
                            this.$router.push('/login');
                        }
                        this.loaded = true;
                        this.error = e.response.data.error;
                    }
                })
        },
        log_out: function() {
            axios.delete('/users/sign_out.json').then(response => {
                this.logged_in = false;
                this.$router.push('/login');
            })
        },
        toggleLanguage: function(){
            this.lang = (this.lang == 'en' ? "pl" : "en")
            Cookies.set('lang', this.lang)
            window.location.reload()
        }
    }

}
</script>
<style scoped>
.hopbutton{
    position: fixed;
    bottom: 15px;
    left: 50%;
    z-index: 999;
}
.hopbutton:hover{
    background-color: #c22026!important;
}
.login_button {
    color: red;
}

p {
    font-size: 1em;
    text-align: center;
}
@media only print {
    nav {
        display: none;
    }
}

nav {
    background-color: #8A8D91;
    height: 100px;
}

img {
    width: 50px;
    height: 50px;
}

nav a {
    margin: 15px;
    font-size: 18px;
}

nav i {
    font-size: initial;
    height: initial;
    line-height: initial;
    padding-top: 6px;
}

nav li.menuitems {
    text-transform: uppercase;
    width: 130px;
    text-align: center !important;
    margin-top: 16px;
    background-color: #BEBBBB;
    height: 84px;
}

nav ul li {
    margin-top: 14px;
}

li.menuitems a {
    color: black !important;
    margin: 0px;
    padding: 0px;
    height: 84px;
    line-height: 1.5;
}

.menuitems i.material-icons {
    font-size: 48px !important;
}

a.selected {
    background-color: #C22026;
    height: 84px;

}

/deep/ .btn-large,
.btn {
    border-radius: 8px !important;
    color: black;
}

.nav-wrapper {
    color: black !important;
}

.logout {
    background-color: #C22026 !important;
}

.upmenu {
    width: 1170px;
    position: absolute;
    margin-left: 80px;
    left: 0;
    right: 0;
    text-align: center;
    letter-spacing: 2.5px;
}

.upmenu-customer {
    width: 1000px;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    letter-spacing: 2.5px;
}

/deep/ form .btn-large {
    width: 338px;
}

.grayed {
    background-color: rgb(138, 141, 145);
    min-height: 100vh;
}

.page-footer {
    background-color: rgb(218, 218, 218);
    color: black !important;
}

.page-footer h6 {
    font-weight: bold;
}

.page-footer p {
    text-align: left;
}

label {
    color: black;
}

i.material-icons {
    font-size: 16px !important;
}

.input-field.inline input {
    margin-bottom: initial;
}
/deep/ .btn-large .preloader-wrapper {
    margin-top: 10px !important;
}

@media only screen and (max-width: 1400px) {
    .hide-under1460 {
        display: none !important;
    }

    .show-under1460 {
        display: block !important;
    }
}

@media only screen and (min-width: 1400px) {
    .show-under1460 {
        display: none !important;
    }
}
@media only screen and (min-width: 1440px) {
      .upmenu {
        margin-left: auto;
        margin-right: auto;
    }
}
.dropdown-trigger .medium {
    font-size: 4rem !important;
}
.dropdown-content .tiny {
    font-size: 15px !important;
}
.dropdown-content li.menuitems {
    margin-top: 0px;
    width: 100%;
    height: 10px;
}
.dropdown-content li.menuitems a{
    height: initial;
}
/deep/ .btn-small{
    color: #000;
    border-radius: 8px;
}

/deep/ .red{
    background-color: #c22026!important;
    border-color: #c22026!important;
}
/deep/ .row{
    margin-bottom: 0px !important;
}
/deep/ .input-field{
    margin-top: 0rem;
    margin-bottom: 0rem;
}
/deep/ select{
    margin-bottom: 8px !important;
}
/deep/ input {
    margin-bottom: 8px;
}
/deep/ .rightlabel {
    text-align: right;
    line-height: 2;
}
/deep/ .leftlabel {
    text-align: left;
    line-height: 2;
}
/deep/ .row .col {
    min-height: 2px !important;
}
/deep/ .cursor-pointer {
    cursor: pointer;
}
</style>